import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class HouseholdExclusion extends BaseModel {
    @Expose() id = "";
    @Expose() title = "";
    @Expose() description = "";
}
